import * as React from "react";
import {DataTable, DataTableProps} from "primereact/datatable";

import { chooseColumn } from "./columns/index";
import { constantTable } from "../../helpers/constants";
import { TableColumn } from "./columns/DefaultColumn/DefaultColumn";


export type DataTableBaseProps = DataTableProps<any> & {
  allColumns: TableColumn[];
  tableName: string;
};

export const DataTableBase: (props: DataTableBaseProps) => React.ReactElement = (props: DataTableBaseProps) => {
  const { allColumns, tableName, ...dataTableProps } = props;
  const dtRef = React.useRef<DataTable<any>>(null);
  const columns = allColumns.map((c, i) => {
    return {
      ...(chooseColumn({ ...c, filters: dataTableProps.filters }, dtRef) as any),
      key: tableName + i,
    };
  });


  return (
    <div className="table-responsive">
      <DataTable
        ref={dtRef}
        emptyMessage={constantTable.emptyMessage}
        // //storage
        // stateKey={tableName}
        // stateStorage="custom"
        // customSaveState={customSaveState}
        // customRestoreState={customRestoreState}
        //sort
        removableSort
        sortMode="multiple"
        //pagination
        paginator
        rows={constantTable.paginatorRows}
        paginatorTemplate={constantTable.paginatorTemplate}
        currentPageReportTemplate={constantTable.currentPageReportTemplate}
        rowsPerPageOptions={constantTable.paginatorRowOptions}
        id={tableName}
        {...dataTableProps}>
        {columns}
      </DataTable>
    </div>
  );
};
